import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Preserve Saved Content snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 * Without this, /me/saved targetId rounds and detail routes 404.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:targetId|creatorId|nextCursorSaveId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

export const savedApi = {
  list: (params) => travelClient.get(travelEndpoints.mySaved, { params, ...snowflakeJson }),
};
